export default "__VITE_ASSET__1b132155__"